// Filename: uidropdown.js
// Timestamp: 2018.05.05-00:30:30 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

import gnnodexuipart from '../gnnodexuipart.js'

import {
  gndom_nodeelem,
  gndom_nodeelemid
} from '../gndom.js'

import {
  gnenumNAME as NAME,
  gnenumXONCHANGE as XONCHANGE,
  gnenumPARTLABEL as PARTLABEL,
  gnenumPARTKEYPART as PARTKEYPART,
  gnenumPARTISACTIVE as PARTISACTIVE
} from '../gnenum.js'

import {
  gnutilNumBoolOrStrIs as utilNumBoolOrStrIs
} from '../gnutil.js'

const xvnode = (ss, cfg, gr, nd, ndx, subj) => {
  const { label, select, option, span } = cfg.h(ndx, nd)
  const {
    disabled,
    labelprimary,
    labelsecondary,
    labeltertiary,
    labelhint,
    isemptyvalue
  } = subj

  return (
    label('.:ui', {
      for: gndom_nodeelemid(nd)
    }, [
      labelprimary &&
        span('.:ui-label-primary', labelprimary),
      labelsecondary &&
        span('.:ui-label-secondary', labelsecondary),
      select('.:ui-select#:key', {
        name: nd.get(NAME),
        disabled: disabled ? 'disabled' : ''
      }, [
        isemptyvalue &&
          option('.:ui-select-option', {
            value: ''
          }, labelhint || '---'),
        ndx.partAtomsMap(nd, part => (
          option('.:ui-select-option', {
            value: part[PARTKEYPART],
            selected: part[PARTISACTIVE] ? 'selected' : ''
          }, part[PARTLABEL])
        ))
      ]),
      labeltertiary &&
        span('.:ui-label-tertiary', labeltertiary)
    ])
  )
}

const xonchange = async (ss, cfg, gr, nd, ndx) => {
  const keyarr = ndx.getlivekeys(ss, cfg, gr, nd, ndx)
  const value = await ndx.returnValsFromPartKeys(ss, cfg, gr, nd, ndx, keyarr)

  ndx.publishev(ss, cfg, nd, XONCHANGE, { value })
}

const setactive = (ss, cfg, gr, nd, ndx, partkey) => {
  const elem = gndom_nodeelem(cfg, nd)
  const selected = []
  const partkeystr = String(partkey)

  if (!utilNumBoolOrStrIs(partkey))
    throw new Error(`invalid partkey, "${partkey}"`)

  Array.from(elem.options || [], option => {
    option.selected = option.value === partkeystr &&
      Boolean(selected.push(option))
  })

  if (!selected.length)
    throw new Error(`selectable option not not found, "${partkey}"`)
}

const xonsubj = async (ss, cfg, gr, nd, ndx, prev, subjns) => {
  const item = await ndx.partAtomsFromFullKeys(ss, cfg, gr, nd, [subjns.value])
  const newpartial = item[0]

  setactive(ss, cfg, gr, nd, ndx, newpartial && newpartial.partkey)

  return true
}

const getlivekeys = (ss, cfg, gr, nd) => {
  const elem = gndom_nodeelem(cfg, nd)

  return [elem.value || '']
}

export default Object.assign({}, gnnodexuipart, {
  type: 'uidropdown',
  xvnode,
  xonchange,
  xonsubj,
  setactive,
  getlivekeys
})
